module.exports = __webpack_public_path__ + "img/acorn-pwa-Tashii-Designs.1e4f689b.png";